import React from 'react';
import MenuIcon from '@material-ui/icons/Menu';
import CTAButton from "../Helper/CTAButton";
import '../NavBar/navBar.css';
import logo from '../images/ziplyne-logo.png';

function Header() {
    const [expanded, setExpanded] = React.useState(false);
    const [collapsed, setCollapsed] = React.useState(false);

    const toggleDropdown = () => {
        setCollapsed(expanded);
        setExpanded(!expanded);
    };

    React.useEffect(() => {
        const responsiveHandler = () => {
            if (window.innerWidth > 600) {
                setExpanded(false);
                setCollapsed(false);
            }
        };

        window.addEventListener("resize", responsiveHandler);

        // Return a function from the effect that removes the event listener
        return () => window.removeEventListener("resize", responsiveHandler);
    }, []);

    return (
        <header>
            <div className={`main-header ${expanded ? "expanded" : ""} ${collapsed ? "collapsed" : ""} `}>
                <a href="/" className="main-header__logo">
                    <img alt="Ziplyne" src={logo} />
                </a>
                <nav className="main-header__nav">
                    {/* This is kind of jank but it works to help the flex-container center the nav links */}
                    <div className="main-header__nav__flex-helper" />

                    <ul className="main-header__nav__links">
                        <li className="main-header__nav__link">
                            <a href="https://ziplyne.com/" >Home</a>
                        </li>
                        <li className="main-header__nav__link">
                            <a href="https://ziplyne.com/product" >Product</a>
                        </li>
                        <li className="main-header__nav__link">
                            <a href="https://ziplyne.com/usecase">Use Cases</a>
                        </li>
                        <li className="main-header__nav__link">
                            <a href="https://ziplyne.com/pricing">Pricing</a>
                        </li>
                        <li className="main-header__nav__link">
                            <a href="https://ziplog.ziplyne.com">Blog</a>
                        </li>
                    </ul>
                    <div className="main-header__nav__cta">
                        <CTAButton className="ziplyne-button--gradient" size="small" variant="contained">
                            Request a Demo
                        </CTAButton>
                    </div>
                </nav>
                <MenuIcon onClick={toggleDropdown} className="main-header__nav__menu-icon">menu</MenuIcon>
            </div>
        </header>
    );
}

export default Header;